import { render, staticRenderFns } from "./DisciplineList.vue?vue&type=template&id=6423dffc&scoped=true&"
import script from "./DisciplineList.vue?vue&type=script&lang=js&"
export * from "./DisciplineList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6423dffc",
  null
  
)

export default component.exports